module.exports = __webpack_public_path__ + "img/performance-logo.2a08afa1.jpg";